export const queryKeys = {
  accountHolders: 'account-holders',
  riskAssessment: 'signup/risk-assessment',
  /*
   * The betAccount key is used to cache the bet account details outside of the @mobi/account package.
   * It uses the cache from the old state management. This cannot be invalidated wihout access to @core.
   */
  betAccount: 'bet-account',
  depositAddCard: 'deposit/add-card',
  depositInitialData: `deposit/initial-data`,
  depositGeneratePayId: 'deposit/generate-payid',
  depositGetBsbDetails: 'deposit/get-bsb-details',
  withdrawDetails: 'withdraw/withdraw-details',
  withdrawCreateZeptoContact: 'withdraw/create-zepto-contact',
  withdrawDeleteZeptoContact: 'withdraw/delete-zepto-contact',
  accountSendOtp: 'account/send-otp',
  accountCountryList: 'account/country-list',
  accountUserContactDetails: 'account/user-contact-details',
  signupPrecommitment: 'signup/precommitment',
  signupCreateWageringBetAccount: 'signup/wagering-account',
  signupApplicationSave: 'signup/application',
  signupApplicationSubmit: 'signup/application-submit',
  signupVerifyDriversLicence: 'signup/drivers-licence',
  signupVerifyMedicare: 'signup/medicare',
  signupVerifyPassport: 'signup/passport',
  precommitmentDetails: 'precommitment-page-details',
  precommitmentDepositLimit: 'precommitment/deposit-limit',
}

export const toastIds = {
  // Contact details
  contactDetailsSuccess: 'contact-details-success',
  contactDetailsError: 'contact-details-error',
  // Deposit
  addCardSuccess: 'add-card-success',
  addCardError: 'add-card-error',
  defaultCardError: 'default-card-error',
  deleteCardError: 'delete-card-error',
  deleteCardSuccess: 'delete-card-success',
  depositError: 'deposit-error',
  depositSuccess: 'deposit-success',
  payIdActivationSuccess: 'payid-activation-success',
  payIdActivationFailure: 'payid-activation-failure',
  // OTP
  createSendOtpError: 'create-send-otp-error',
  // SignUp
  depositLimitSuccess: 'deposit-limit-success',
  // Withdrawal
  pendingWithdrawal: 'withdrawal-pending',
  withdrawalError: 'withdrawal-error',
  createZeptoContactError: 'create-zepto-contact-error',
  createZeptoContactSuccess: 'create-zepto-contact-success',
  deleteZeptoContactError: 'delete-zepto-contact-error',
  deleteZeptoContactSuccess: 'delete-zepto-contact-success',
  withdrawalChannelChange: 'withdrawal-channel-change',
}

/** Locations needed for CRM wrapper processing */
export enum TABLocation {
  Mobi = 538,
  Desktop = 285,
}

export const routes = {
  blockDebitCard: '/account/block-debit-card',
  personalDetails: '/account/personal-details',
}
